<template>
  <artisio-modal size="lg" :visible="modal.show" :title="computedTitle" @hidden="onHidden"
                 @hide="onHide" hide-footer
                 :ok-title="$t('Submit')" :content-in-form="false" scrollable>
    <div class="row">
      <div class="col-md-12 mb-3" v-if="itemLocations.length">
        <table class="table table-sm mb-0">
              <tr>
                <th class="border-top-0" style="width:15%">{{$t('Item Location')}}</th>
                <th class="border-top-0" style="width:25%">{{$t('Container Type')}}</th>
                <th class="border-top-0" style="width:10%">{{$t('Container Count')}}</th>
                <th class="border-top-0" style="width:40%">{{$t('Note')}}</th>
                <th class="border-top-0" style="width:10%">{{$t('Is Primary')}}</th>
              </tr>
              <tr v-for="(item, index) in itemLocations" :key="`${item.uuid}-${index}`">
                <td>
                  {{item.item_location.name}}
                </td>
                <td>
                  {{getContainerName(item.container_type)}}
                </td>
                <td>
                  {{getContainerName(item.container_count)}}
                </td>
                <td>
                  {{item.note}}
                </td>
                <td style="color: green;">
                  <span class="badge bg-success text-white" v-if="item.is_primary">{{ $t('Yes') }}</span>
                  <span class="badge bg-danger text-white" v-else>{{ $t('No') }}</span>
                </td>
              </tr>
            </table>
      </div>
    </div>
  </artisio-modal>
</template>

<script>
import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal.vue";
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions} = createNamespacedHelpers('receipts');
const {mapState: globalMapState} = createNamespacedHelpers('global');

export default {
  name: "ReceiptItemLocationModal",
  components: {
    ArtisioModal
  },
  computed: {
    ...mapState({
      modal: state => state.receiptItemLocationModal,
      itemLocations: state => state.receiptItemLocationModal.itemLocations,
    }),
    ...globalMapState(['receiptContainerOptions']),
    computedTitle() {
      return this.$i18n.t("Item Locations")
    },
  },
  methods: {
    ...mapActions(['hideReceiptItemLocationModal']),
    onHide() {
      this.hideReceiptItemLocationModal()
    },
    onHidden() {
      this.hideReceiptItemLocationModal();
    },
    getContainerName(key) {
      for (let i in this.receiptContainerOptions) {
        if (this.receiptContainerOptions[i].value === key) {
          return this.receiptContainerOptions[i].text;
        }
      }
      return key;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
